import React from 'react';
import { Link } from 'react-router-dom';
import UserNav from './UserNav';

/**
 * Reusable header component with logo and navigation
 * @param {boolean} showSubtitle - Whether to show the subtitle under the logo
 * @param {function} onHelpToggle - Optional callback for help toggle in UserNav
 */
const Header = ({ showSubtitle = true, onHelpToggle }) => {
  return (
    <header className="App-header">
      <div className="header-nav">
        <div className="logo-section">
          <Link to="/" className="logo">Rec-Chord</Link>
          {showSubtitle && <p className="app-subtitle">Your Voice, Perfectly Penned</p>}
        </div>
        <UserNav onHelpToggle={onHelpToggle} />
      </div>
    </header>
  );
};

export default Header;
